import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { buildImgSrc, buildImgSrcSet } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import styles from './Hero.module.css'

export function Hero() {
  const intl = useIntl()
  const groupsHeader = useCMSPageField('Groups.header') ?? null
  const { data } = useBookingDraftQuery()

  const { backgroundImageUrl, logoUrl, title, description } = groupsHeader ?? {}
  if (!data || !groupsHeader) {
    return null
  }

  const heroTitle = (title && title.replace('{group_name}', data?.groupInformation?.name ?? '')) || intl.formatMessage(
    { id: 'groups_checkout_steps_extra_services_title' },
    { group_name: data?.groupInformation?.name ?? '' },
  )
  const heroDescription = description || intl.formatMessage({ id: 'groups_checkout_steps_extra_services_description' })

  return (
    <div className={styles.heroContainer}>
      {backgroundImageUrl
        ? (
            <img
              className={styles.backgroundImage}
              src={buildImgSrc(backgroundImageUrl, 1920, 399)}
              srcSet={buildImgSrcSet(backgroundImageUrl, [375, 600, 720, 1440, 1440, 2000, 2400])}
              sizes="100vw"
              alt=""
            />
          )
        : null}
      <div className={styles.wrapper}>
        <div className={styles.heroContentContainer}>
          {logoUrl && (
            <img
              className={styles.logoImage}
              src={buildImgSrc(logoUrl, 117, 40) ?? ''}
              srcSet={buildImgSrc(logoUrl, 117, 40) ?? ''}
              alt=""
            />
          )}
          <Typography as="h1" className={styles.heroTitle}>{heroTitle}</Typography>
          <Typography as="p" className={styles.heroDescription}>{heroDescription}</Typography>
        </div>
      </div>
    </div>
  )
}
